export default "__VITE_ASSET__19b40a43__"